import { render, staticRenderFns } from "./VipPackages.vue?vue&type=template&id=c134a41e&scoped=true&"
import script from "./VipPackages.vue?vue&type=script&lang=ts&"
export * from "./VipPackages.vue?vue&type=script&lang=ts&"
import style0 from "./vip_packages.scss?vue&type=style&index=0&id=c134a41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c134a41e",
  null
  
)

export default component.exports